module.exports = __webpack_public_path__ + "static/media/article-card-default@phone.6ad941df.jpg";